import { Row, Col } from "antd";
import { withTranslation, TFunction } from "react-i18next";
import { useHistory, useLocation } from "react-router-dom";
import { SvgIcon } from "../../common/SvgIcon";
import Container from "../../common/Container";

import i18n from "i18next";
import {
  FooterSection,
  Title,
  NavLink,
  Extra,
  LogoContainer,
  Para,
  Large,
  Chat,
  Empty,
  FooterContainer,
  Language,
  Label,
  LanguageSwitch,
  LanguageSwitchContainer,
} from "./styles";

interface SocialLinkProps {
  href: string;
  src: string;
}

const Footer = ({ t }: { t: TFunction }) => {
  const history = useHistory();
  const location = useLocation();

  const handleChange = (language: string) => {
    i18n.changeLanguage(language);
  };

  const navigateToSection = (id: string) => {
    if (location.pathname !== "/" && location.pathname !== "/home") {
      // Nếu không ở trang home, navigate về home trước
      history.push("/");
      // Sau đó scroll đến section sau một chút delay
      setTimeout(() => {
        const element = document.getElementById(id) as HTMLDivElement;
        if (element) {
          element.scrollIntoView({
            behavior: "smooth",
          });
        }
      }, 100);
    } else {
      // Nếu đã ở trang home, scroll trực tiếp
      const element = document.getElementById(id) as HTMLDivElement;
      if (element) {
        element.scrollIntoView({
          behavior: "smooth",
        });
      }
    }
  };

  // const SocialLink = ({ href, src }: SocialLinkProps) => {
  //   return (
  //     <a
  //       href={href}
  //       target="_blank"
  //       rel="noopener noreferrer"
  //       key={src}
  //       aria-label={src}
  //     >
  //       <SvgIcon src={src} width="25px" height="25px" />
  //     </a>
  //   );
  // };

  return (
    <>
      <FooterSection>
        <Container>
          <Row justify="space-between">
            <Col lg={10} md={10} sm={12} xs={12}>
              <Language>Liên hệ</Language>
              <Large to="/">Trạm Sạc</Large>
              <Para>
                Ứng dụng tìm kiếm trạm sạc xe điện tiện lợi và nhanh chóng
              </Para>
              <a href="mailto:nnthien.242@gmail.com">
                <Chat>Liên hệ với chúng tôi</Chat>
              </a>
            </Col>
            <Col lg={8} md={8} sm={12} xs={12}>
              <Title>Chính sách</Title>
              <Large to="/privacy">Privacy</Large>
              <Large to="/terms">Terms</Large>
            </Col>
            <Col lg={6} md={6} sm={12} xs={12}>
              <Empty />
              <div style={{ display: "flex", flexDirection: "row", gap: "12px", flexWrap: "wrap" }}>
                <div 
                  style={{ 
                    backgroundColor: "#000", 
                    color: "#fff", 
                    padding: "8px 12px", 
                    borderRadius: "4px", 
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    transition: "all 0.3s ease",
                    minWidth: "160px"
                  }}
                  onClick={() => window.open('https://apps.apple.com', '_blank')}
                >
                  <div style={{ fontSize: "16px" }}>🍎</div>
                  <div>
                    <div style={{ fontSize: "10px", lineHeight: "1.2" }}>Tải về trên</div>
                    <div style={{ fontSize: "12px", fontWeight: "bold" }}>App Store</div>
                  </div>
                </div>
                <div 
                  style={{ 
                    backgroundColor: "#000", 
                    color: "#fff", 
                    padding: "8px 12px", 
                    borderRadius: "4px", 
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    transition: "all 0.3s ease",
                    minWidth: "160px"
                  }}
                  onClick={() => window.open('https://play.google.com', '_blank')}
                >
                  <div style={{ fontSize: "16px" }}>▶️</div>
                  <div>
                    <div style={{ fontSize: "10px", lineHeight: "1.2" }}>TẢI NỘI DUNG TRÊN</div>
                    <div style={{ fontSize: "12px", fontWeight: "bold" }}>Google Play</div>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
          <Row justify="space-between">
            <Col lg={10} md={10} sm={12} xs={12}>
              <Empty />
              <Language>Email</Language>
              <Para>nnthien.242@gmail.com</Para>
            </Col>
            <Col lg={8} md={8} sm={12} xs={12}>
              <Title>Công ty</Title>
              <div onClick={() => navigateToSection("about")} style={{ cursor: "pointer", color: "#52c41a", fontSize: "16px", marginBottom: "8px" }}>Về chúng tôi</div>
              <div onClick={() => navigateToSection("features")} style={{ cursor: "pointer", color: "#52c41a", fontSize: "16px", marginBottom: "8px" }}>Tính năng</div>
              <div onClick={() => navigateToSection("contact")} style={{ cursor: "pointer", color: "#52c41a", fontSize: "16px", marginBottom: "8px" }}>Liên hệ</div>
            </Col>
            <Col lg={6} md={6} sm={12} xs={12}>
              <Label htmlFor="select-lang">{t("Language")}</Label>
              <LanguageSwitchContainer>
                <LanguageSwitch onClick={() => handleChange("vi")}>
                  <div style={{ fontSize: "16px", fontWeight: "bold" }}>🇻🇳</div>
                </LanguageSwitch>
                <LanguageSwitch onClick={() => handleChange("en")}>
                  <div style={{ fontSize: "16px", fontWeight: "bold" }}>🇺🇸</div>
                </LanguageSwitch>
              </LanguageSwitchContainer>
            </Col>
          </Row>
        </Container>
      </FooterSection>
      <Extra>
        <Container border={true}>
          <Row
            justify="space-between"
            align="middle"
            style={{ paddingTop: "3rem" }}
          >
            <NavLink to="/">
              <LogoContainer>
                <div style={{ fontSize: "20px", fontWeight: "bold", color: "#52c41a" }}>
                  Trạm Sạc
                </div>
              </LogoContainer>
            </NavLink>
            <FooterContainer>
              <div style={{ color: "#666", fontSize: "14px" }}>
                © nnt.242 2025
              </div>
            </FooterContainer>
          </Row>
        </Container>
      </Extra>
    </>
  );
};

export default withTranslation()(Footer);
